<ng-container *ngIf="earnRedeem$ | async as earnRedeem">
  <myclubrewards-editable-card-header
    [config]="earnRedeem"
  ></myclubrewards-editable-card-header>

  <ng-container *ngIf="earnRedeem.items.length">
    <!-- <div class="earn-back-wrapper"> -->
    <div class="card-wrapper">
      <div class="earn-back"></div>
      <div class="earn-card-box">
        <myclubrewards-card
          *ngFor="let item of earnRedeem.items"
          [config]="item"
          class="earn-card"
        ></myclubrewards-card>
      </div>
    </div>
    <!-- </div> -->
    <div class="footer">
      <div
        class="footer-text-box"
        [innerHTML]="earnRedeem.footerText | safeHtml: 'html'"
      ></div>
    </div>
  </ng-container>
</ng-container>
